import loginRouter from '@/components/login/router/router.js'//
import homeRouter from '@/components/home/router/router.js'//
import oa from '@/components/oa/router/router.js'//
import oa_portal from '@/components/oa/router/portal.js'//


var routers = [];
export default routers.concat(loginRouter).concat(homeRouter).concat(oa).concat(oa_portal);


// WEBPACK FOOTER //
// ./src/router/router.js